import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isArray as D, isEqual as ii } from "../util/code-utils.js";
import ti from "../models/push-token.js";
import { logger as E, EncodingUtils as ei } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
import yt from "./utils/push-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";
var na = /*#__PURE__*/function () {
  function na(i, t, e, s, r, n, o, u, a, h, c) {
    _classCallCheck(this, na);
    this.en = i, this.sn = t, this.on = e, this.un = r, this.an = n, this.hn = o, this.h = u, this.cn = a, this.fn = h, this.j = c, this.en = i, this.sn = t, this.on = e, this.ln = s + "/safari/" + t, this.un = r || "/service-worker.js", this.hn = o, this.h = u, this.cn = a || !1, this.fn = h || !1, this.j = c, this.dn = yt.pn(), this.bn = yt.yn();
  }
  _createClass(na, [{
    key: "mn",
    value: function mn() {
      return this.fn;
    }
  }, {
    key: "gn",
    value: function gn(i, t, e, s, r) {
      var _this = this;
      i.unsubscribe().then(function (i) {
        i ? _this.vn(t, e, s, r) : (E.error("Failed to unsubscribe device from push."), "function" == typeof r && r(!1));
      })["catch"](function (i) {
        E.error("Push unsubscription error: " + i), "function" == typeof r && r(!1);
      });
    }
  }, {
    key: "wn",
    value: function wn(i, t, e) {
      var s;
      var r = function (i) {
        if ("string" == typeof i) return i;
        if (0 !== i.endpoint.indexOf("https://android.googleapis.com/gcm/send")) return i.endpoint;
        var t = i.endpoint;
        var e = i;
        return e.kn && -1 === i.endpoint.indexOf(e.kn) && (t = i.endpoint + "/" + e.kn), t;
      }(i);
      var n = null,
        o = null;
      var u = i;
      if (null != u.getKey) try {
        var _i = Array.from(new Uint8Array(u.getKey("p256dh"))),
          _t = Array.from(new Uint8Array(u.getKey("auth")));
        n = btoa(String.fromCharCode.apply(null, _i)), o = btoa(String.fromCharCode.apply(null, _t));
      } catch (i) {
        E.error(si(i));
      }
      var a = function (i) {
        var t;
        return i.options && (t = i.options.applicationServerKey) && t.byteLength && t.byteLength > 0 ? btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(t)))).replace(/\+/g, "-").replace(/\//g, "_") : null;
      }(u);
      null === (s = this.en) || void 0 === s || s.Pn(r, t, n, o, a), r && "function" == typeof e && e(r, n, o);
    }
  }, {
    key: "Dn",
    value: function Dn() {
      var i;
      null === (i = this.en) || void 0 === i || i.Sn(!0);
    }
  }, {
    key: "An",
    value: function An(i, t) {
      var e;
      null === (e = this.en) || void 0 === e || e.Sn(!1), E.info(i), "function" == typeof t && t(!1);
    }
  }, {
    key: "jn",
    value: function jn(i, t, e, s) {
      var _this2 = this;
      var r;
      if ("default" === t.permission) try {
        window.safari.pushNotification.requestPermission(this.ln, i, {
          api_key: this.sn,
          device_id: (null === (r = this.on) || void 0 === r ? void 0 : r.fe().id) || ""
        }, function (t) {
          "granted" === t.permission && _this2.en && _this2.en.setPushNotificationSubscriptionType(User.NotificationSubscriptionTypes.OPTED_IN), _this2.jn(i, t, e, s);
        });
      } catch (i) {
        this.An("Could not request permission for push: " + i, s);
      } else "denied" === t.permission ? this.An("The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard.", s) : "granted" === t.permission && (E.info("Device successfully subscribed to push."), this.wn(t.deviceToken, new Date(), e));
    }
  }, {
    key: "requestPermission",
    value: function requestPermission(i, t, e) {
      var s = function s(_s) {
        switch (_s) {
          case "granted":
            return void ("function" == typeof i && i());
          case "default":
            return void ("function" == typeof t && t());
          case "denied":
            return void ("function" == typeof e && e());
          default:
            E.error("Received unexpected permission result " + _s);
        }
      };
      var r = !1;
      if ("default" !== window.Notification.permission) s(Notification.permission);else {
        var _i2 = window.Notification.requestPermission(function (i) {
          r && s(i);
        });
        _i2 ? _i2.then(function (i) {
          s(i);
        }) : r = !0;
      }
    }
  }, {
    key: "vn",
    value: function vn(i, t, e, s) {
      var _this3 = this;
      var r = {
        userVisibleOnly: !0
      };
      null != t && (r.applicationServerKey = t), i.pushManager.subscribe(r).then(function (i) {
        E.info("Device successfully subscribed to push."), _this3.wn(i, new Date(), e);
      })["catch"](function (i) {
        yt.isPushBlocked() ? (E.info("Permission for push notifications was denied."), "function" == typeof s && s(!1)) : (E.error("Push subscription failed: " + i), "function" == typeof s && s(!0));
      });
    }
  }, {
    key: "xn",
    value: function xn() {
      if (this.cn) return navigator.serviceWorker.getRegistration(this.un);
      var i = this.an ? {
        scope: this.an
      } : void 0;
      return navigator.serviceWorker.register(this.un, i).then(function () {
        return navigator.serviceWorker.ready.then(function (i) {
          return i && "function" == typeof i.update && i.update()["catch"](function (i) {
            E.info("ServiceWorker update failed: " + i);
          }), i;
        });
      });
    }
  }, {
    key: "Nn",
    value: function Nn(i) {
      this.cn || (i.unregister(), E.info("Service worker successfully unregistered."));
    }
  }, {
    key: "subscribe",
    value: function subscribe(i, t) {
      var _this4 = this;
      if (!yt.isPushSupported()) return E.info(na.Un), void ("function" == typeof t && t(!1));
      if (this.dn) {
        if (!this.cn && null != window.location) {
          var _i3 = this.un;
          -1 === _i3.indexOf(window.location.host) && (_i3 = window.location.host + _i3), -1 === _i3.indexOf(window.location.protocol) && (_i3 = window.location.protocol + "//" + _i3);
        }
        if (yt.isPushBlocked()) return void this.An("Notifications from this site are blocked. This may be a temporary embargo or a permanent denial.", t);
        if (this.h && !this.h.Wn() && 0 === this.h.Ft()) return E.info("Waiting for VAPID key from server config before subscribing to push."), void this.h._n(function () {
          _this4.subscribe(i, t);
        });
        var e = function e() {
            E.info("Permission for push notifications was denied."), "function" == typeof t && t(!1);
          },
          r = function r() {
            var i = "Permission for push notifications was ignored.";
            yt.isPushBlocked() && (i += " The browser has automatically blocked further permission requests for a period (probably 1 week)."), E.info(i), "function" == typeof t && t(!0);
          },
          n = yt.isPushPermissionGranted(),
          o = function o() {
            !n && _this4.en && _this4.en.setPushNotificationSubscriptionType(User.NotificationSubscriptionTypes.OPTED_IN), _this4.xn().then(function (e) {
              if (null == e) return E.error("No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerPush."), void ("function" == typeof t && t(!0));
              e.pushManager.getSubscription().then(function (r) {
                var n;
                var o = null;
                if (null != (null === (n = _this4.h) || void 0 === n ? void 0 : n.Wn()) && (o = ei.Tn(_this4.h.Wn())), r) {
                  var _n,
                    u = null,
                    a = null;
                  if (_this4.j && (_n = _this4.j.lt(s.ct.In)), _n && !D(_n)) {
                    var _i4;
                    try {
                      _i4 = ti.qn(_n).Vn;
                    } catch (t) {
                      _i4 = null;
                    }
                    null == _i4 || isNaN(_i4.getTime()) || 0 === _i4.getTime() || (u = _i4, a = new Date(u), a.setMonth(u.getMonth() + 6));
                  }
                  null != o && r.options && r.options.applicationServerKey && r.options.applicationServerKey.byteLength && r.options.applicationServerKey.byteLength > 0 && !ii(o, new Uint8Array(r.options.applicationServerKey)) ? (r.options.applicationServerKey.byteLength > 12 ? E.info("Device was already subscribed to push using a different VAPID provider, creating new subscription.") : E.info("Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription."), _this4.gn(r, e, o, i, t)) : r.expirationTime && new Date(r.expirationTime).valueOf() <= new Date().valueOf() ? (E.info("Push subscription is expired, creating new subscription."), _this4.gn(r, e, o, i, t)) : _n && D(_n) ? _this4.gn(r, e, o, i, t) : null == a ? (E.info("No push subscription creation date found, creating new subscription."), _this4.gn(r, e, o, i, t)) : a.valueOf() <= new Date().valueOf() ? (E.info("Push subscription older than 6 months, creating new subscription."), _this4.gn(r, e, o, i, t)) : (E.info("Device already subscribed to push, sending existing subscription to backend."), _this4.wn(r, u, i));
                } else _this4.vn(e, o, i, t);
              })["catch"](function (i) {
                E.error("Error checking current push subscriptions: " + i);
              });
            })["catch"](function (i) {
              E.error("ServiceWorker registration failed: " + i);
            });
          };
        this.requestPermission(o, r, e);
      } else if (this.bn) {
        if (null == this.hn || "" === this.hn) return E.error("You must supply the safariWebsitePushId initialization option in order to use registerPush on Safari"), void ("function" == typeof t && t(!0));
        var _e = window.safari.pushNotification.permission(this.hn);
        this.jn(this.hn, _e, i, t);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(i, t) {
      var _this5 = this;
      if (!yt.isPushSupported()) return E.info(na.Un), void ("function" == typeof t && t());
      this.dn ? navigator.serviceWorker.getRegistration(this.un).then(function (e) {
        e ? e.pushManager.getSubscription().then(function (s) {
          s ? (_this5.Dn(), s.unsubscribe().then(function (s) {
            s ? (E.info("Device successfully unsubscribed from push."), "function" == typeof i && i()) : (E.error("Failed to unsubscribe device from push."), "function" == typeof t && t()), _this5.Nn(e);
          })["catch"](function (i) {
            E.error("Push unsubscription error: " + i), "function" == typeof t && t();
          })) : (E.info("Device already unsubscribed from push."), "function" == typeof i && i());
        })["catch"](function (i) {
          E.error("Error unsubscribing from push: " + i), "function" == typeof t && t();
        }) : (E.info("Device already unsubscribed from push."), "function" == typeof i && i());
      }) : this.bn && (this.Dn(), E.info("Device unsubscribed from push."), "function" == typeof i && i());
    }
  }]);
  return na;
}();
export { na as default };
na.Un = "Push notifications are not supported in this browser.";